import { UploadRequestOption } from 'rc-upload/lib/interface';

const request = new XMLHttpRequest();

export const dummyRequest = (options: UploadRequestOption): void => {
  const { onSuccess } = options;

  if (!onSuccess) {
    return;
  }

  setTimeout(() => {
    onSuccess('ok', request);
  }, 0);
};
